import { Button, Tooltip } from "@blueprintjs/core";
import React from "react";
import { observer, inject } from "mobx-react";
import { copyToClipboard } from "../fns/util";
import LoginButton from "../utils/LoginButton";

class Landing extends React.Component {
  state = {};
  render() {
    return (
      <div className="landing bp3-dark">
        <div
          className="searchbar-title"
          style={{ display: "flex", alignItems: "flex-end" }}
        >
          <div>NewChart</div>
          <div
            style={{
              color: "grey",
              filter: "grayscale(100%)",
              fontSize: "xx-large",
            }}
          >
            ✃
          </div>
        </div>
        <br />
        <LoginButton />
        <div className="footer">
          Radical Health <br />
          <br />
          <br />
          <div style={{ fontSize: "smaller" }}>Internal Use Only</div> <br />
          <br />
          <Tooltip
            content="human@radicalhealth.care"
            className="bp3-dark"
            minimal
            usePortal={false}
          >
            <Button
              minimal
              intent="primary"
              text="Email Support"
              rightIcon="duplicate"
              icon="envelope"
              onClick={() => copyToClipboard("human@radicalhealth.care")}
            />
          </Tooltip>
          <Tooltip content="+919560094626" className="bp3-dark" minimal usePortal={false}>
            <Button
              minimal
              intent="success"
              text="Call Support"
              rightIcon="duplicate"
              icon="phone"
              onClick={() => copyToClipboard("+919560094626")}
            />
          </Tooltip>
        </div>
      </div>
    );
  }
}
export default inject("authStore")(observer(Landing));
